// extracted by mini-css-extract-plugin
module.exports = {"content":"SettingsVkModalWrap_content__2C72d","isLoading":"SettingsVkModalWrap_isLoading__1BwtS","loader":"SettingsVkModalWrap_loader__OiE2Q"};